export default __webpack_public_path__ + "static/media/p-bandung-sukabumi.09bd9743.jpg";